export interface SiaChoice {
  title?: string;
  description?: string;
  items?: SiaChoiceItem[];
}

export interface SiaChoiceItem {
  navigationScript?: string;
  navigationMenu?: string;
  icon?: string;
  name?: string;
}

// export class SiaChoiceItemClass implements SiaChoiceItem {
//   navigationMenu = '';
//   icon = '';
//   name = '';
// }

export class SiaChoiceClass implements SiaChoice {
  title = '';
  items: SiaChoiceItem[] = [];
}
